export default __webpack_public_path__ + "static/RunRight9-41f098adbe965ca48859d30f96214a09.mp3";